import { Autocomplete, Button, Dialog, DialogActions, DialogContent, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { useGetAllTaskTemplate } from '../../../services/react-query/task_templates/useGetAllTaskTemplate';
import { headerTypographyProps } from '../../../styles/sxStyling';


// TODO abstract up commonalitites with event template

interface ITemplateModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onCreate: (templateUuid: string | null) => void;
}

type TemplateDisplay = {
  name: string;
  uuid: string | null;
};

export default function TemplateModal({ isOpen, onCancel, onCreate }: ITemplateModalProps) {
  const blankTemplate: TemplateDisplay = { name: 'Blank Template', uuid: null };
  const [selectedOption, setSelectedOption] = useState<TemplateDisplay | null>(null);
  const { data, isLoading: isGetAllEventTemplatesLoading } = useGetAllTaskTemplate({
    params: {
      per_page: 0,
    },
  });

  const displayOptions: TemplateDisplay[] = _.map(
    [blankTemplate, ..._.sortBy(data?.data ?? [], 'name')],
    (template) => ({ name: template.name, uuid: template.uuid })
  );

  const handleAdd = () => {
    if (!selectedOption) return;
    onCreate(selectedOption.uuid);
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <Typography {...headerTypographyProps} sx={{ m: 2 }}>
        Please choose which task template to use
      </Typography>
      <DialogContent>
        <Autocomplete<TemplateDisplay>
          loading={isGetAllEventTemplatesLoading}
          options={displayOptions}
          onChange={(_, option) => setSelectedOption(option)}
          getOptionLabel={(template) => template.name}
          value={selectedOption}
          renderInput={(params) => <TextField {...params} autoFocus label="Templates" />}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" disabled={!selectedOption} color="primary" onClick={handleAdd}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
